module.exports = function() {
  return new Worker(__webpack_public_path__ + "f862de9756bb58a376fe.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReactiveQR/qr_decode.worker.js
// module id = 195
// module chunks = 0